import * as React from 'react';
import { Code, getActiveSupplier, getImpersonationUser } from '../../lib/utils';
import { DataService } from '../../services/DataService';
import { CompressedDepartmentReported, Department, DepartmentFunctionArgs } from '../../services/API/Departments';
import i18n from '../../i18n';

export interface ISupplierBarProps {
}

export default function SupplierBar (props: ISupplierBarProps) {
  const [supplier, setSupplier] = React.useState("");
  const {currentDepartment} = useCurrentDepartmentHook();
  
  React.useEffect(() => {
    const activeSupplier = getActiveSupplier();
    if(activeSupplier){
      DataService.Suppliers.GetByOrgNr(activeSupplier)
      .then(sup => {
        setSupplier(`${sup.supplierName} - ${sup.supplierOrgNr}`)
      })
    }
  }, []);

  return (
    <>
    {
      supplier &&
      <div className='supplier-bar'>{currentDepartment() && currentDepartment()?.department + ' - '}{supplier}</div>
    }
    </>
  );
}
type ReportedPeriodsMap = Record<string, CompressedDepartmentReported>;
type MissedText = { kickbackText: string; statisticText: string };

const normalizePeriodKey = (p: any): string => {
  if (!p) return "";
  const s = String(p).trim();
  return s.length >= 7 ? s.slice(0, 7) : s; // yyyy-MM
};

const monthIndex = (yyyyMM: string): number => {
  const y = Number(yyyyMM.slice(0, 4));
  const m = Number(yyyyMM.slice(5, 7));
  if (!Number.isFinite(y) || !Number.isFinite(m)) return Number.NaN;
  return y * 12 + (m - 1);
};

const currentMonthKey = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

// behåll bara månader STRICTLY BEFORE current month
const isPastMonth = (yyyyMM: string) => {
  const k = normalizePeriodKey(yyyyMM);
  const idx = monthIndex(k);
  return Number.isFinite(idx) && idx < monthIndex(currentMonthKey());
};

const formatMonthYear = (yyyyMM: string, locale: string) => {
  const key = normalizePeriodKey(yyyyMM);
  const d = new Date(`${key}-01T00:00:00Z`);
  return d.toLocaleDateString(locale, { month: "long", year: "numeric" });
};

export const useCurrentDepartmentHook = () => {
  const [department, setDepartment] = React.useState<Department | null | undefined>(undefined);
const [departmentLoaded, setDepartmentLoaded] = React.useState(false);
  const [reportedPeriods,setReportedPeriods] = React.useState<{[key:string]:CompressedDepartmentReported}>({})
  const supplier = getActiveSupplier()
  
  // React.useEffect(() => {
    
  //   async function fetchDepartment(){
  //     try {
  //         const res = await DataService.Departments.GetUserAssignedDepartment();
  //       if(res.Content.response){
  //         setDepartment(res.Content.response)
          
  //       }
  //     } catch (error) {
  //       console.log(`Fetch failed..${error}`)
  //     }
  //   }
  //   fetchDepartment()
  // },[supplier])
  React.useEffect(() => {
  let cancelled = false;

  async function fetchDepartment() {
    try {
      const res = await DataService.Departments.GetUserAssignedDepartment();
      if (cancelled) return;

      // IMPORTANT: null betyder "laddat men ingen dept"
      setDepartment(res.Content.response ?? null);
      setDepartmentLoaded(true);
    } catch (error) {
      console.log(`Fetch failed..${error}`);
      if (!cancelled) {
        setDepartment(null);         // eller leave undefined om du vill skilja error
        setDepartmentLoaded(true);
      }
    }
  }

  fetchDepartment();
  return () => { cancelled = true; };
}, [supplier]);
  React.useEffect(() => {
    if (!department || department === null) return;
    async function fetchMissedPeriods(){
      try {
        const da:DepartmentFunctionArgs = {reportCheck:{departmentId:department?.id,report:4}}
        const res = await DataService.Departments.CheckAlreadyReportedDepartment(da)
        setReportedPeriods(res)  
      } catch (error) {
        console.log(`Fetch failed..${error}`)
      }
      
    }
    fetchMissedPeriods()
  },[department])
 
  // const getMissedPeriodsAsString = async () =>{
  //   const res = await getMissedPeriods(false)
  //   const missedText:{kickbackText:string,statisticText:string} = {kickbackText:'',statisticText:''}
  //   if (typeof res !== 'undefined' &&  Object.keys(res).length > 0){
  //     if(typeof res['kickbackReport'] !== 'undefined'){ 
  //      missedText.kickbackText += res['kickbackReport']
  //     }
  //     if(typeof res['statisticReport'] !== 'undefined'){
  //       missedText.statisticText += res['statisticReport']
  //     }
  //   }
  //   return missedText
  // }
//   const getMissedPeriodsAsString = async () => {
//   const res = await getMissedPeriods(false);
//   return {
//     kickbackText: res?.["kickbackReport"] ?? "",
//     statisticText: res?.["statisticReport"] ?? ""
//   };
// };
const getMissedPeriodsRaw = (): ReportedPeriodsMap => {
  return reportedPeriods;
};

const getMissedPeriodsText = (): MissedText => {
  const out: MissedText = { kickbackText: "", statisticText: "" };

  Object.entries(reportedPeriods).forEach(([key, value]) => {
    const periodKey = normalizePeriodKey(key);

    // FAILSAFE: ta bort current + framtid
    if (!isPastMonth(periodKey)) return;

    if (value.kickbackReport && typeof  value.invoicesNotReported?.length !== 'undefined' && value.invoicesNotReported.length > 0) {
      const label = formatMonthYear(periodKey, i18n.language);
      out.kickbackText = out.kickbackText ? `${out.kickbackText},${label}` : label;
    }

    if (value.statisticReport && value.kickbackReport) {
      const label = formatMonthYear(periodKey, i18n.language);
      out.statisticText = out.statisticText ? `${out.statisticText},${label}` : label;
    }
  });

  return out;
};


 const currentDepartment = () => department;

  // const getMissedPeriods = async (original:boolean) => {
  //   if(original == true ){
  //     return reportedPeriods
  //   }
  //   else{
  //     const returnResult:{[key:string]:string} = {} 
  //     Object.entries(reportedPeriods).forEach(([key,value]) => {
  //       if(value.kickbackReport){
  //         returnResult['kickbackReport'] = typeof returnResult['kickbackReport'] == 'undefined' ? new Date(key).toLocaleDateString(i18n.language,{month:'long',year:'numeric'}) : returnResult['kickbackReport'] +','+ new Date(key).toLocaleDateString(i18n.language,{month:'long',year:'numeric'})
  //       }
  //       if(value.statisticReport){
  //         returnResult['statisticReport'] = typeof returnResult['statisticReport'] == 'undefined' ? new Date(key).toLocaleDateString(i18n.language,{month:'long',year:'numeric'}) : returnResult['statisticReport'] +','+ new Date(key).toLocaleDateString(i18n.language,{month:'long',year:'numeric'})
  //       }
  //     })

  //    return returnResult
  //   } 
  // }
//   const getMissedPeriods = async (original: boolean) => {
//   if (original === true) return reportedPeriods;

//   const returnResult: { [key: string]: string } = {};

//   Object.entries(reportedPeriods).forEach(([key, value]) => {
//     const periodKey = normalizePeriodKey(key);

//     // FAILSAFE: ta bort current + framtid
//     if (!isPastMonth(periodKey)) return;

//     if (value.kickbackReport) {
//       const label = formatMonthYear(periodKey, i18n.language);
//       returnResult["kickbackReport"] =
//         typeof returnResult["kickbackReport"] === "undefined"
//           ? label
//           : `${returnResult["kickbackReport"]},${label}`;
//     }

//     if (value.statisticReport) {
//       const label = formatMonthYear(periodKey, i18n.language);
//       returnResult["statisticReport"] =
//         typeof returnResult["statisticReport"] === "undefined"
//           ? label
//           : `${returnResult["statisticReport"]},${label}`;
//     }
//   });

//   return returnResult;
// };


  return{
    department,
    reportedPeriods,
    currentDepartment,
    // getMissedPeriods,
    // getMissedPeriodsAsString
     getMissedPeriodsRaw,
  getMissedPeriodsText,
  departmentLoaded
  }
}